export function videoModal(triggerSelector, openBodyClass) {
  const $triggers = $(triggerSelector);

  if (!$triggers.length) {
    return;
  }

  let activeModal = null;
  let activeTrigger = null;

  const stopVideo = ($modal) => {
    const video = $modal.find("video").get(0);

    if (!video) {
      return;
    }

    video.pause();
    video.currentTime = 0;
  };

  const closeModal = ($modal) => {
    if (!$modal.length) {
      return;
    }

    $modal.removeClass("is-open").attr("aria-hidden", "true");
    $("body").removeClass(openBodyClass);
    stopVideo($modal);

    if (activeTrigger) {
      activeTrigger.focus();
    }

    activeModal = null;
    activeTrigger = null;
  };

  const openModal = ($modal, trigger) => {
    const video = $modal.find("video").get(0);

    if (!$modal.length) {
      return;
    }

    if (activeModal && activeModal.get(0) !== $modal.get(0)) {
      closeModal(activeModal);
    }

    activeModal = $modal;
    activeTrigger = trigger;

    $modal.addClass("is-open").attr("aria-hidden", "false");
    $("body").addClass(openBodyClass);
    $modal.find("[data-video-modal-close]").first().trigger("focus");

    if (!video) {
      return;
    }

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  };

  $triggers.on("click", function () {
    const modalId = $(this).attr("data-video-modal-open");
    const $modal = $("#" + modalId);

    if (!$modal.length) {
      return;
    }

    openModal($modal, this);
  });

  $(document).on("click", "[data-video-modal-close]", function () {
    closeModal($(this).closest("[data-video-modal]"));
  });

  $(document).on("keydown", function (event) {
    if (event.key === "Escape" && activeModal) {
      closeModal(activeModal);
    }
  });
}